<script lang="ts" setup>
import { onUnmounted } from 'vue';
import FeedbackBottom from './FeedbackBottom.vue';
import FeedbackQuestion from './FeedbackQuestion.vue';
import { useFeedback } from '../composable/useFeedback';
import PlacholderQuestion from './PlacholderQuestion.vue';
import FeedbackSelectOption from './FeedbackSelectOption.vue';
import FeedbackDone from './FeedbackDone.vue';
type Props = {
  onClose: () => void;
  feedbackType: string;
  onBack: () => void;
};

const { onClose, feedbackType } = defineProps<Props>();

const {
  questionActive,
  activeQuestionIndex,
  disableNextButton,
  totalStep,
  clearStore,
  isSubmitLoading,
  onSubmit,
  buttonText,
  isFetchingQuestions,
  getQuestion,
  firstQuestion,
  isLatestQuestion,
  isDone,
} = useFeedback(onClose, feedbackType);
getQuestion();
onUnmounted(() => {
  clearStore();
});
</script>

<template>
  <perfect-scrollbar
    id="feedback-scroll"
    :options="{
      suppressScrollX: true,
    }">
    <div id="feedback-form" class="gp-check-list-body !p-4">
      <FeedbackDone v-if="isDone" />
      <template v-else>
        <PlacholderQuestion v-if="isFetchingQuestions" />
        <template v-else>
          <template v-if="!!firstQuestion?.id">
            <div class="!mb-2 w-full !text-sm !font-medium text-light-mode-high-contrast">
              {{ firstQuestion?.question_content }}
            </div>
            <FeedbackSelectOption :question="firstQuestion" />
            <div
              v-if="activeQuestionIndex !== 0"
              class="!mb-2 !mt-4 w-full !text-sm !font-medium text-light-mode-high-contrast">
              {{ questionActive?.question_content }}
            </div>
            <FeedbackQuestion v-if="activeQuestionIndex !== 0" />
          </template>
        </template>
      </template>
    </div>
  </perfect-scrollbar>
  <FeedbackBottom
    v-if="isLatestQuestion && firstQuestion && !isDone"
    :loading="isSubmitLoading"
    :button-text="buttonText"
    :disable="disableNextButton"
    :step="Math.min(activeQuestionIndex + 1, totalStep)"
    :total-step="totalStep"
    @submit="onSubmit" />
</template>
<style lang="scss" scoped>
.gp-check-list-body {
  transition: height 500ms;
  max-height: calc(100vh - 350px);
}
</style>
